var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('component-sidebar',{attrs:{"force-mini":false}}),_c('div',{staticClass:"gray-bg",attrs:{"id":"page-wrapper"}},[_c('component-header'),_c(_vm.$route.name,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }